import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { User } from "./add-user-modal";
import { LocaleString } from "models/locale";
import { adminDoPostListUser } from "services/admin/list-user";
import {
  StyledIcon,
  StyledText,
  StyledWrapper,
} from "./add-user-model-sending.styles";
import { adminDoPostListUserInvitation } from "services/admin/list-invitation";
import { adminDoPostListInvitationEmail } from "services/admin/list-invitation-email";
import { showSuccess } from "lib/notification";
import { List } from "models/list";
import { faPaperPlane } from "components/icon-library";
import { parse } from "lib/locale";

interface SendingProps {
  list: List;
  users: User[];
  invite: boolean;

  // optional, if chose to send invites
  subject?: LocaleString;
  message?: LocaleString;
  onFinish: () => Promise<void>;
}

const Sending: FunctionComponent<SendingProps> = ({
  list,
  users,
  invite,
  subject,
  message,
  onFinish,
}) => {
  const [index, toggleIndex] = useState(0);
  const [finished, toggleFinished] = useState(false);

  useEffect(() => {
    const magic = async () => {
      if (index === users.length) {
        toggleFinished(true);
        return;
      }

      try {
        const { email, locale } = users[index];

        // create user (this will invoke prefill and might take some time)
        const user = await adminDoPostListUser(list, email, locale);

        if (invite && subject && message) {
          // create invite
          const invitation = await adminDoPostListUserInvitation(
            list,
            user.uuid,
          );

          // send email
          await adminDoPostListInvitationEmail(
            list,
            invitation.uuid,
            parse(subject, user.locale),
            parse(message, user.locale),
          );
        }

        // increase index
        setTimeout(() => toggleIndex(index + 1), 1000);
      } catch (err) {
        // nada?
        console.error(err);
      }
    };
    magic();
  }, [index]);

  useEffect(() => {
    if (finished) {
      showSuccess("Käyttäjät lisätty onnistuneesti!");
      setTimeout(() => onFinish(), 1000);
    }
  }, [finished]);

  return (
    <StyledWrapper>
      <StyledIcon icon={faPaperPlane} />
      <StyledText>
        {finished && <Fragment>Kaikki lisätty. Viimeistellään!</Fragment>}
        {!finished && (
          <Fragment>
            Lisätään {index + 1} / {users.length}
          </Fragment>
        )}
      </StyledText>
    </StyledWrapper>
  );
};

export default Sending;
